(function () {
  if (window.__oestGiftWithPurchaseInitialized) return;
  window.__oestGiftWithPurchaseInitialized = true;

  const RULES = [
    {
      label: 'Oest Lubi',
      triggerHandles: ['oest-dupla-hidratacao-intima'],
      giftHandle: 'oest-lubi',
      giftVariantId: 50901672427763,
      declinedAttribute: 'oest_lubi_gift_declined_count',
      confirmPopupType: 'gwp-lubi-confirm',
      strict: false,
      confirmLineFlag: 'free',
    },
    {
      label: 'Oest Forte Acerola',
      triggerHandles: [
        'oest-forte-acerola-duplo-1-oest-forte-acerola-com-30-off',
        'oest-forte-chocolate-duplo-1-oest-forte-acerola-com-30-off',
        'oest-forte-duplo-oest-forte-acerola-de-brinde',
      ],
      giftHandle: 'oest-forte-acerola',
      giftVariantId: null,
      declinedAttribute: 'oest_forte_acerola_gift_declined_count',
      confirmPopupType: 'gwp-forte-acerola-confirm',
      strict: false,
      confirmLineFlag: 'discounted',
    },
  ];

  RULES.forEach((rule) => {
    rule.confirmResolve = null;
    rule.previousTriggerQty = null;
  });

  const STRICT_RULES = RULES.filter((rule) => rule.strict);
  const ALL_TRIGGER_HANDLES = RULES.flatMap((rule) => rule.triggerHandles);

  let processingLock = false;
  let pendingRecheck = false;
  let queue = Promise.resolve();
  let selfDispatching = false;
  let lastCart = null;

  const SYNC_CLASS = 'gwp-syncing';
  const SYNC_TIMEOUT_MS = 10000;
  let syncTimer = null;

  const syncStyle = document.createElement('style');
  syncStyle.textContent = `
    html.${SYNC_CLASS} button[name="checkout"],
    html.${SYNC_CLASS} .cart-drawer__checkoutButtons-additional,
    html.${SYNC_CLASS} .main-cart__checkoutButtons-additional {
      opacity: 0.45;
    }
    html.${SYNC_CLASS} button[name="checkout"],
    html.${SYNC_CLASS} .cart-drawer__checkoutButtons-additional *,
    html.${SYNC_CLASS} .main-cart__checkoutButtons-additional * {
      cursor: not-allowed !important;
    }
    html.${SYNC_CLASS} .cart-drawer__checkoutButtons-additional,
    html.${SYNC_CLASS} .main-cart__checkoutButtons-additional {
      pointer-events: none;
    }
  `;
  document.head.appendChild(syncStyle);

  document.addEventListener(
    'click',
    (event) => {
      if (!document.documentElement.classList.contains(SYNC_CLASS)) return;
      const blocked = event.target.closest(
        'button[name="checkout"], .cart-drawer__checkoutButtons-additional, .main-cart__checkoutButtons-additional'
      );
      if (!blocked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  function setSyncing(active) {
    clearTimeout(syncTimer);
    document.documentElement.classList.toggle(SYNC_CLASS, active);
    if (active) syncTimer = setTimeout(() => setSyncing(false), SYNC_TIMEOUT_MS);
  }

  function runExclusive(task) {
    processingLock = true;
    const run = queue.then(task, task).finally(() => {
      processingLock = false;
      if (pendingRecheck) {
        pendingRecheck = false;
        checkCart();
      }
    });
    queue = run.catch(() => {});
    return run;
  }

  function sectionsToRender() {
    let sections = HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString();
    if (document.querySelector('cart-page')) {
      sections += ',' + HELPER_UTIL.sectionRenderUtil('main-cart').getSectionsString();
    }
    return sections;
  }

  function cartQty(cart, handles) {
    return cart.items.filter((item) => handles.includes(item.handle)).reduce((sum, item) => sum + item.quantity, 0);
  }

  function getDeclinedCount(rule, cart) {
    const raw = cart.attributes && cart.attributes[rule.declinedAttribute];
    const count = parseInt(raw, 10);
    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function fetchCart() {
    return fetch(`${window.routes.cart_url}.js`).then((response) => response.json());
  }

  function dispatchCartChange(detail) {
    selfDispatching = true;
    HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerCartChange, document, detail);
    selfDispatching = false;
  }

  function setDeclinedCount(rule, count) {
    HELPER_UTIL.fetchData({
      method: 'POST',
      url: `${window.Shopify.routes.root}cart/update.js`,
      data: JSON.stringify({ attributes: { [rule.declinedAttribute]: count > 0 ? String(count) : '' } }),
      config: { headers: { 'Content-Type': 'application/json' } },
      onsuccess: () => {},
      onerror: (error) => console.error('gift-with-purchase: failed to reset decline count', error),
    });
  }

  function resolveGiftVariantId(rule) {
    if (rule.giftVariantId) return Promise.resolve(rule.giftVariantId);
    if (!rule.variantIdPromise) {
      rule.variantIdPromise = fetch(`${window.Shopify.routes.root}products/${rule.giftHandle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const variant = product.variants.find((candidate) => candidate.available) || product.variants[0];
          return variant ? variant.id : null;
        })
        .catch(() => null)
        .then((id) => {
          if (!id) rule.variantIdPromise = null;
          return id;
        });
    }
    return rule.variantIdPromise;
  }

  async function addGiftUnits(rule, quantity) {
    const variantId = await resolveGiftVariantId(rule);
    if (!variantId) {
      console.error(`gift-with-purchase: could not find a variant for ${rule.label}`);
      return null;
    }

    return new Promise((resolve) => {
      HELPER_UTIL.fetchData({
        method: 'POST',
        url: `${window.Shopify.routes.root}cart/add.js?sections=${sectionsToRender()}`,
        data: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        config: { headers: { 'Content-Type': 'application/json' } },
        onsuccess: (data) => {
          if (data.status) {
            console.error(`gift-with-purchase: failed to add ${rule.label}`, data.description);
            resolve(null);
            return;
          }
          dispatchCartChange({ sections: data.sections });
          resolve(data);
        },
        onerror: (error) => {
          console.error(`gift-with-purchase: failed to add ${rule.label}`, error);
          resolve(null);
        },
      });
    });
  }

  function updateGiftLine(rule, key, quantity, extraAttributes) {
    const body = { updates: { [key]: quantity } };
    if (extraAttributes) body.attributes = extraAttributes;

    return new Promise((resolve) => {
      HELPER_UTIL.fetchData({
        method: 'POST',
        url: `${window.Shopify.routes.root}cart/update.js?sections=${sectionsToRender()}`,
        data: JSON.stringify(body),
        config: { headers: { 'Content-Type': 'application/json' } },
        onsuccess: (data) => {
          if (data.status) {
            console.error(`gift-with-purchase: failed to update ${rule.label}`, data.description);
            resolve(null);
            return;
          }
          lastCart = data;
          dispatchCartChange({ sections: data.sections, cart: data });
          resolve(data);
        },
        onerror: (error) => {
          console.error(`gift-with-purchase: failed to update ${rule.label}`, error);
          resolve(null);
        },
      });
    });
  }

  async function adjustGiftLines(rule, cart, targetQuantity) {
    const giftLines = cart.items.filter((item) => item.handle === rule.giftHandle);
    const currentGiftQty = giftLines.reduce((sum, item) => sum + item.quantity, 0);
    if (currentGiftQty === targetQuantity) return;

    if (targetQuantity > currentGiftQty) {
      await addGiftUnits(rule, targetQuantity - currentGiftQty);
      return;
    }

    const target = [...giftLines].sort((a, b) => (b.total_discount || 0) - (a.total_discount || 0))[0];
    if (!target) return;

    const reduceBy = Math.min(currentGiftQty - targetQuantity, target.quantity);
    const newCart = await updateGiftLine(rule, target.key, target.quantity - reduceBy);

    const stillNeeded = currentGiftQty - reduceBy - targetQuantity;
    if (newCart && stillNeeded > 0) {
      await adjustGiftLines(rule, newCart, targetQuantity);
    }
  }

  function setGiftQuantity(rule, cart, targetQuantity) {
    return runExclusive(() => adjustGiftLines(rule, cart, targetQuantity));
  }

  function targetGiftQty(rule, cart) {
    const triggerQty = cartQty(cart, rule.triggerHandles);
    const giftQty = cartQty(cart, [rule.giftHandle]);
    let declinedCount = getDeclinedCount(rule, cart);

    if (triggerQty === 0 && declinedCount > 0) {
      declinedCount = 0;
      setDeclinedCount(rule, 0);
    }

    const previousTriggerQty = rule.previousTriggerQty;
    rule.previousTriggerQty = triggerQty;

    const expectedGiftQty = Math.max(0, triggerQty - declinedCount);
    if (rule.strict) return expectedGiftQty === giftQty ? null : expectedGiftQty;

    // First read of the cart: only top up the gift, never remove units the customer added.
    if (previousTriggerQty === null) return giftQty < expectedGiftQty ? expectedGiftQty : null;

    const deltaTrigger = triggerQty - previousTriggerQty;
    if (deltaTrigger === 0) return null;

    const target = Math.max(0, giftQty + deltaTrigger);
    return target === giftQty ? null : target;
  }

  function evaluateCart(cart) {
    if (processingLock) {
      pendingRecheck = true;
      return;
    }

    lastCart = cart;

    const adjustments = [];
    RULES.forEach((rule) => {
      const target = targetGiftQty(rule, cart);
      if (target !== null) adjustments.push({ rule, target });
    });

    if (adjustments.length === 0) {
      setSyncing(false);
      return;
    }

    if (adjustments.some(({ rule, target }) => target < cartQty(cart, [rule.giftHandle]))) setSyncing(true);
    const unlock = () => setSyncing(false);
    runExclusive(async () => {
      for (const { rule, target } of adjustments) {
        await adjustGiftLines(rule, cart, target);
      }
    }).then(unlock, unlock);
  }

  function checkCart() {
    fetchCart().then(evaluateCart).catch((error) => console.error('gift-with-purchase: failed to read cart', error));
  }

  function resolveConfirm(rule, result) {
    if (!rule.confirmResolve) return;
    const resolve = rule.confirmResolve;
    rule.confirmResolve = null;
    resolve(result);
  }

  function confirmRemoval(rule) {
    const popup = document.querySelector(`popup-component[popup-type="${rule.confirmPopupType}"]`);
    if (!popup) {
      console.error('gift-with-purchase: confirmation popup not found, allowing removal without warning');
      return Promise.resolve(true);
    }

    HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showPopup, popup, { popupType: rule.confirmPopupType });

    return new Promise((resolve) => {
      rule.confirmResolve = resolve;
    });
  }

  document.addEventListener('click', (event) => {
    RULES.forEach((rule) => {
      const confirmButton = event.target.closest(`popup-component[popup-type="${rule.confirmPopupType}"] [popup-confirm]`);
      if (!confirmButton) return;
      resolveConfirm(rule, true);
      HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.hidePopup, confirmButton, { popupType: rule.confirmPopupType });
    });
  });

  document.addEventListener(_EVENT_HELPER.hidePopup, (event) => {
    const popupType = event.detail && event.detail.popupType;
    const rule = RULES.find((candidate) => candidate.confirmPopupType === popupType);
    if (rule) resolveConfirm(rule, false);
  });

  function clearRemovePreloader(target) {
    target.querySelector('[remove-lineitem]')?.classList.remove('active-preloader');
  }

  function resetSelector(rule, target) {
    if (rule.strict) return;
    if (typeof target.resetQuantitySelector === 'function') target.resetQuantitySelector();
  }

  async function handleGiftDecrease(rule, target, oldQuantity, newQuantity) {
    const confirmed = await confirmRemoval(rule);
    if (!confirmed) {
      resetSelector(rule, target);
      clearRemovePreloader(target);
      return;
    }

    const key = target.getAttribute('item-key');
    const currentDeclinedCount = lastCart ? getDeclinedCount(rule, lastCart) : 0;
    const newDeclinedCount = currentDeclinedCount + (oldQuantity - newQuantity);

    const result = await runExclusive(() =>
      updateGiftLine(rule, key, newQuantity, {
        [rule.declinedAttribute]: newDeclinedCount > 0 ? String(newDeclinedCount) : '',
      })
    );

    if (!result) {
      resetSelector(rule, target);
      clearRemovePreloader(target);
    }
  }

  document.addEventListener(
    _EVENT_HELPER.OnLineItemUpdate,
    (event) => {
      const target = event.target;
      if (!target || !target.dataset) return;

      const rule = RULES.find((candidate) => candidate.giftHandle === target.dataset.handle);
      if (!rule) return;
      if (rule.confirmLineFlag && target.dataset[rule.confirmLineFlag] !== 'true') return;

      const oldQuantity = Number(target.getAttribute('item-quantity'));
      const newQuantity = Number(event.detail && event.detail.quantity);
      if (!Number.isFinite(oldQuantity) || !Number.isFinite(newQuantity) || newQuantity >= oldQuantity) return;

      event.stopImmediatePropagation();
      handleGiftDecrease(rule, target, oldQuantity, newQuantity);
    },
    true
  );

  let checkoutGuardActive = false;
  let checkoutGuardBypass = false;

  function expectedGiftQty(rule, cart) {
    return Math.max(0, cartQty(cart, rule.triggerHandles) - getDeclinedCount(rule, cart));
  }

  function hasExcessGift(rule, cart) {
    return cartQty(cart, [rule.giftHandle]) > expectedGiftQty(rule, cart);
  }

  async function reconcileBeforeCheckout() {
    await queue;
    let cart = await fetchCart();
    for (const rule of STRICT_RULES) {
      if (hasExcessGift(rule, cart)) {
        await setGiftQuantity(rule, cart, expectedGiftQty(rule, cart));
      }
    }
    cart = await fetchCart();
    return STRICT_RULES.every((rule) => !hasExcessGift(rule, cart));
  }

  document.addEventListener(
    'submit',
    (event) => {
      if (checkoutGuardBypass) return;
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (checkoutGuardActive) return;
      checkoutGuardActive = true;

      const buttons = document.querySelectorAll('button[name="checkout"]');
      buttons.forEach((button) => (button.disabled = true));

      reconcileBeforeCheckout()
        .then((ok) => {
          if (!ok) {
            console.error('gift-with-purchase: cart still holds the gift without its trigger, checkout blocked');
            return;
          }
          buttons.forEach((button) => (button.disabled = false));

          const liveSubmitter = submitter.isConnected
            ? submitter
            : Array.from(document.querySelectorAll('button[name="checkout"]')).find(
                (button) => button.form && button.className === submitter.className
              );
          if (!liveSubmitter) {
            console.error('gift-with-purchase: checkout button not found after cart refresh');
            return;
          }

          checkoutGuardBypass = true;
          try {
            liveSubmitter.form.requestSubmit(liveSubmitter);
          } finally {
            checkoutGuardBypass = false;
          }
        })
        .catch((error) => console.error('gift-with-purchase: checkout guard failed', error))
        .finally(() => {
          checkoutGuardActive = false;
          buttons.forEach((button) => (button.disabled = false));
        });
    },
    true
  );

  document.addEventListener(
    _EVENT_HELPER.OnLineItemUpdate,
    (event) => {
      const target = event.target;
      if (!target || !target.dataset || !ALL_TRIGGER_HANDLES.includes(target.dataset.handle)) return;

      const oldQuantity = Number(target.getAttribute('item-quantity'));
      const newQuantity = Number(event.detail && event.detail.quantity);
      if (Number.isFinite(oldQuantity) && Number.isFinite(newQuantity) && newQuantity < oldQuantity) {
        setSyncing(true);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => checkCart());

  document.addEventListener(_EVENT_HELPER.triggerCartChange, () => {
    if (selfDispatching) return;
    checkCart();
  });

  document.addEventListener(_EVENT_HELPER.showCartPopup, () => {
    if (selfDispatching) return;
    checkCart();
  });
})();
